import { tw } from "tw-lite";

export const Title = tw("h1")`font-titles text-4xl font-extrabold md:text-5xl`;

export const Subtitle = tw("h2")`font-titles text-3xl font-bold md:text-4xl`;

export const SectionTitle = tw("h3")`font-titles text-2xl font-bold md:text-3xl`;
